import API from "@aws-amplify/api"

const emailAPIName = "emailApi"

export interface EmailPostBody {
  subject: string
  text: string
}

export const sendEmail = async (path: string, body: EmailPostBody) =>
  await API.post(emailAPIName, path, { body });
